import NfcCardOrdersScreen from './NfcCardOrdersScreen';

export default NfcCardOrdersScreen;
